module.exports = __webpack_public_path__ + "static/media/ka-choice.b82c5ec7.mp4";